import { createContext } from "react";


const BeamsContext = createContext({});

export default BeamsContext;